import { useState, useEffect } from 'react'

import Api from 'services/api'

const useDeviceSearch = (deviceIds) => {
  const [devices, setDevices] = useState(null)
  const [invalidDeviceIds, setInvalidDeviceIds] = useState(null)
  const [areDevicesLoaded, setAreDevicesLoaded] = useState(false)
  const [serverErrorOccurred, setServerErrorOccurred] = useState(false)

  useEffect(() => {
    // for subsequent calls we need to reset back to no data
    setDevices(null)
    setInvalidDeviceIds(null)
    setAreDevicesLoaded(false)
    setServerErrorOccurred(false)

    if (!deviceIds?.length) {
      setAreDevicesLoaded(true)
      return
    }

    Api.Devices.search(deviceIds)
      .then(res => {
        if (res.devices) {
          setDevices(res.devices)
          setInvalidDeviceIds(res.invalidDeviceIds)
          setAreDevicesLoaded(true)
        }
      })
      .catch(() => {
        setServerErrorOccurred(true)
        setDevices(null)
        setInvalidDeviceIds(null)
        setAreDevicesLoaded(true)
      })
  }, [JSON.stringify(deviceIds.sort())]) // eslint-disable-line react-hooks/exhaustive-deps

  return { devices, invalidDeviceIds, areDevicesLoaded, serverErrorOccurred }
}

export default useDeviceSearch
